import type { Video_Provider } from "@/graphql/generated-types";
import type { IFileState, IMedia } from "@/interfaces";
import type { MediaType } from "@/types";

const toMedia = (
  item: IFileState,
  type: MediaType,
  provider?: Video_Provider,
): IMedia => {
  const url = item.url || item.base64 || "";

  return {
    type,
    url,
    provider,
  };
};

const toYoutubeVideo = (link: string) => {
  const regex = /(?:\?v=|\/embed\/|\.be\/)([a-zA-Z0-9_-]{11})/;
  const match = link.match(regex);
  if (match && match[1]) {
    return `https://www.youtube.com/embed/${match[1]}`;
  }

  return "";
};

const toVideoLink = (link: string) => {
  if (link.includes("youtube.com")) {
    return toYoutubeVideo(link);
  }

  return link;
};

export default {
  toMedia,
  toVideoLink,
};
